import {initThreeIphonesRow} from "../components/three-iphones";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger.js";
import {isMobile, isTablet} from "../components/helpers";

export function initSamaragisLanding() {
    if (!$('#samaragis_landing').length) return;
    initThreeIphonesRow()
    if ($('.samaragis-themes').length) {
        gsap.registerPlugin(ScrollTrigger);

        gsap.set(".samaragis-themes .themes-row .item", {y: 100, opacity: 0});

        ScrollTrigger.batch('.samaragis-themes .themes-row .item', {
            scroller: isMobile() || isTablet() ? '' : '.scroller',
            onEnter: batch => {
                gsap.to(batch, {opacity: 1, y: 0, stagger: {each: 0.15}})
            },
            onLeaveBack: batch => {
                gsap.to(batch, {y: 100, opacity: 0, stagger: {each: 0.15}})
            }
        })
    }
}
